import React from 'react';
import Api from "../../services/Api";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent, IonDatetime,
  IonHeader,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import {ProfileI} from "../../interfaces/Profile";
import {MessageInterface} from "../../interfaces/MessageInterface";
import {FriendInterface} from "../../interfaces/FriendInterface";
import {RouteComponentProps} from "react-router";
import {History} from "history";

interface ComponentProps extends RouteComponentProps<{}> {
  history: History
}

interface ComponentState {
  person: ProfileI
  friends: Array<FriendInterface>
  rooms: Array<any>
  showCreateRoom: boolean
  showRoomMessages: boolean
  showRoomSend: boolean
  showTime: boolean
  messages: Array<MessageInterface>
  chosenRoom: any
  text: string
  loaded: boolean
  error: string
}

export default class Rooms extends React.Component<ComponentProps, ComponentState> {

  private api = Api.getInstance();

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      person: {} as ProfileI,
      friends: [],
      rooms: [],
      messages: [],
      loaded: false,
      showCreateRoom: false,
      showRoomMessages: false,
      showTime: false,
      showRoomSend: false,
      chosenRoom: {},
      text: '',
      error: '',
    }
  }

  componentDidMount() {
    this.getData();
  }

  private getData = () => {
    this.api.get('djarvtest/rooms').then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            person: resultJson.person,
            friends: resultJson.friends,
            rooms: resultJson.rooms,
            loaded: true
          });
        }
      });
    });
  }

  updateText = (event: any) => {
    this.setState({text: event.target.value})
  }

  sendRoomView = () => {
    return (
      <div className="p-4 text_center">
        <h2>Skicka meddelande till {this.state.chosenRoom.name}</h2>
        <div className="mt-8">
          <textarea cols={40} rows={4} placeholder="Skriv ett meddelande" value={this.state.text}
                    onChange={event => this.updateText(event)}/>
        </div>
        <div className="mt-8">
          <IonButton onClick={() => this.sendRoomMessage(0)}>Skicka</IonButton>
        </div>
      </div>
    )
  }

  createRoomView = () => {
    return (
      <div className="p-4 text_center">
        <h2>Skapa ett rum</h2>
        <div className="mt-8">
          <input type="text" placeholder="Rummets namn" value={this.state.text}
                    onChange={event => this.updateText(event)}/>
        </div>
        <div className="mt-4">
          <p>Medlemmar:</p>
          {
            this.state.friends.map(friend => {
              return (
                <div key={"room_friend_" + friend.id} className="mt-2">
                  {friend.firstName}
                </div>
              )
            })
          }
        </div>
        <div className="mt-8">
          <IonButton onClick={() => this.createRoom()}>Skapa</IonButton>
        </div>
      </div>
    )
  }

  roomMessagesView = () => {
    return (
      <div className="p-4">
        <h2 className="text_center">Meddelanden i {this.state.chosenRoom.name}</h2>
        {
          this.state.messages.map(message => {
            const fromYou = message.senderId === this.state.person.id
            let alignClass = fromYou ? "text_right" : "text_left"
            let from = fromYou ? "Du" : "Person " + message.senderId
            return (
              <div key={"message_" + message.createdAt} className={"mt-4 px-1 " + alignClass}>
                <p style={{fontSize: "12px", paddingBottom: "2px", color: "#999"}}>{from} {message.createdAt}</p>
                <div className="whitespace-pre-line">
                  {message.text}
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  sendRoomMessage = (messageType: number) => {
    const data: MessageInterface = {
      roomId: this.state.chosenRoom.id,
      text: this.state.text,
      json: '',
      messageType: messageType,
      reportedDate: null,
      version: 'message',
      read: false
    }

    this.api.post('send_message', data).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            showRoomSend: false,
            chosenRoom: {},
            text: ''
          });
        }
      });
    });
  }

  createRoom = () => {
    const participants = []
    for (const friend of this.state.friends) {
      participants.push(friend.friendId)
    }
    const data = {
      name: this.state.text,
      participants: participants
    }

    this.api.post('create_room', data).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            showCreateRoom: false,
            text: ''
          });
          this.getData()
        }
      });
    });
  }

  showCreateRoom = () => {
    this.setState({showCreateRoom: true})
  }

  showRoomMessages = (room: any) => {
    this.api.get('message_from_room/' + room.id).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            messages: resultJson.messages,
            showRoomMessages: true,
            chosenRoom: room
          });
        }
      });
    });
  }

  showRoomSend = (room: any) => {
    this.setState({showRoomSend: true, chosenRoom: room})
  }

  talk = (room: any) => {
    let url = '/walk/djarvtest/talk/me/' + this.state.person.firstName + '/' + room.randomKey
    this.props.history.push(url)
  }

  render() {
    if (!this.state.loaded) {
      return (
        <div className="mt-8 text_center">Laddar rum...</div>
      )
    }
    return (
      <IonPage>
        <IonContent>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton text="" defaultHref="/walk/djarvtest" />
              </IonButtons>
              <IonTitle>{this.state.person.firstName}s rum</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonModal isOpen={this.state.showCreateRoom} className="modal_centered"
                    onDidDismiss={() => this.setState({showCreateRoom: false})}>
            {this.createRoomView()}
          </IonModal>
          <IonModal isOpen={this.state.showRoomSend} className="modal_centered"
                    onDidDismiss={() => this.setState({showRoomSend: false})}>
            {this.sendRoomView()}
          </IonModal>
          <IonModal isOpen={this.state.showRoomMessages} className="modal_centered"
                    onDidDismiss={() => this.setState({showRoomMessages: false})}>
            {this.roomMessagesView()}
          </IonModal>
          <IonModal isOpen={this.state.showTime} className="modal_small"
                    onDidDismiss={() => this.setState({showTime: false})}>
            <IonDatetime
                hourCycle="h23"
                presentation="time"
                placeholder="Längd"
                cancelText="Avbryt"
                doneText="Klar"
                value="01:30"
                min="00:05"
                max="04:00"
                minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"
                showDefaultButtons={true}
                onIonChange={e => console.log(e.detail)}
            />
          </IonModal>
          <div className="cheap_desktop px-4">

            <div className="mt-8 flex justify-between">
              <h2>Dina rum:</h2>
              <div className="cursor-pointer underline" onClick={() => this.showCreateRoom()}>Skapa rum</div>
            </div>
            {
              this.state.rooms.map((room: any) => {
                return (
                  <div key={'room_' + room.id} className="mt-2 flex justify-between">
                    <p style={{minWidth: "45vw"}}><b>{room.name}</b></p>
                    <div onClick={() => this.showRoomMessages(room)} className="cursor-pointer underline">
                      Läs
                    </div>
                    <div onClick={() => this.showRoomSend(room)} className="cursor-pointer underline">
                      Skicka
                    </div>
                    <div onClick={() => this.talk(room)} className="cursor-pointer underline">
                      Prata
                    </div>
                  </div>
                )
              })
            }

            <div className="mt-4 cursor-pointer underline"
                 onClick={() => this.setState({showTime: true})}>Välj längd</div>

          </div>
          </IonContent>
      </IonPage>
    );
  }
}
